import VehicleRegisterPopup from "./VehicleRegisterPopup";

export { VehicleRegisterPopup };
export default VehicleRegisterPopup;
